import { Component, OnInit, Inject, ViewChild, Input } from '@angular/core';
import { take } from 'rxjs/operators';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { FormGroup, FormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ManifestoEmbarquePainelService } from 'src/app/services/manifesto-embarque-painel.service';
import { PaginacaoComponent } from 'src/app/@shared/components';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ModalManifestoDetalhesEmbarqueComponent } from 'src/app/@shared/components/modal-manifesto-detalhes-embarque/modal-manifesto-detalhes-embarque.component';

@Component({
  selector: 'app-modal-manifesto-embarque-painel-detalhe',
  templateUrl: './modal-manifesto-embarque-painel-detalhe.component.html',
  styleUrls: ['./modal-manifesto-embarque-painel-detalhe.component.scss']
})
export class ModalManifestoEmbarquePainelDetalheComponent implements OnInit {
  habilitarBaixa = false;
  featureId;

  public modalItem: any;
  public isLoadingTransporte = false;
  public isLoadingDevolucao = false;
  public isDownloading = false;
  public meBaixado;
  public error = {} as any;
  public isMobile: boolean;

  public displayedColumnsTransporte: string[] = [
    'numeroCompletoManifesto',
    'volume',
    'NRT',
    'valor',
    'qtdRessalvas'
  ];


  public displayedColumnsDevolucao: string[] = [
    'numeroCompletoManifesto',
    'volume',
    'NRT',
    'valor',
    'qtdRessalvas'
  ];

  public pagingDevolucao = { index: 0, size: 10, length: 0 };
  public pagingTransporte = { index: 0, size: 10, length: 0 };
  public devolucaoCollection: MatTableDataSource<any> = new MatTableDataSource<any>();
  public transporteCollection: MatTableDataSource<any> = new MatTableDataSource<any>();
  @ViewChild(PaginacaoComponent, { static: false }) paginator: PaginacaoComponent;

  public codBarrasDetalheForm: FormGroup = new FormGroup({
    codigoBarras: new FormControl(),
  });

  get codigoBarras() { return this.codBarrasDetalheForm.get('codigoBarras').value; }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: ManifestoEmbarquePainelService,
    private ref: MatDialogRef<ModalManifestoEmbarquePainelDetalheComponent>,
    public dialog: MatDialog,
    public router: Router,
    public snackBar: MatSnackBar,
    public authService: AuthService,
  ) {
    if (!this.featureId) { this.featureId = 'paineis.manifesto-embarque.painel-manifesto-embarque' }
    this.modalItem = data.item;
    this.meBaixado = data.item.baixado;
  }

  ngOnInit() {
    this.authService.checkFeature(`${this.featureId}.habilita-baixa`).subscribe(temPermissao => {
      if (temPermissao === true) this.habilitarBaixa = true;
    });

    this.getManifestoEmbarqueDetalhesTransporte(this.modalItem.manifestoEmbarqueId);
    this.getManifestoEmbarqueDetalhesDevolucao(this.modalItem.manifestoEmbarqueId);
  }

  public getManifestoEmbarqueDetalhesDevolucao(manifestoEmbarqueId: number, shouldResetPagination: boolean = true) {

    if (this.codigoBarras && this.codigoBarras != null && ((Number(this.codigoBarras) && Number.parseInt(this.codigoBarras) > 2147483647) || (Number(this.codigoBarras) && !Number.isSafeInteger(Number.parseInt(this.codigoBarras))))) {
      this.openSnackBar('Inteiro maior do que o permitido!', 'OK', 5000, 'warning-snackbar');
      return;
    }

    this.isLoadingDevolucao = true;
    this.devolucaoCollection.data = null;

    this.resetOrNotPagination(shouldResetPagination);

    this.service.getManifestoEmbarqueDetalhesDevolucao({
      manifestoEmbarqueId: manifestoEmbarqueId,
      agenteId: this.modalItem.agenteId,
      paginaAtual: this.pagingDevolucao.index,
      itensPorPagina: this.pagingDevolucao.size,
      codigoBarras: this.codigoBarras,
    })
      .pipe(take(1))
      .subscribe(
        (response: HttpResponse<any>) => {
          this.devolucaoCollection.data = response.body;
          if (response.body.length > 0) {
            this.pagingDevolucao.length = response.body[0].totalCount;
          }
          this.isLoadingDevolucao = false;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoadingDevolucao = false;
          this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
        });
  }

  public getManifestoEmbarqueDetalhesTransporte(manifestoEmbarqueId: number, shouldResetPagination: boolean = false) {

    if (this.codigoBarras && this.codigoBarras != null && ((Number(this.codigoBarras) && Number.parseInt(this.codigoBarras) > 2147483647) || (Number(this.codigoBarras) && !Number.isSafeInteger(Number.parseInt(this.codigoBarras))))) {
      this.openSnackBar('Inteiro maior do que o permitido!', 'OK', 5000, 'warning-snackbar');
      return;
    }

    this.isLoadingTransporte = true;
    this.transporteCollection.data = null;

    this.resetOrNotPagination(shouldResetPagination);

    this.service.getManifestoEmbarqueDetalhesTransporte({
      manifestoEmbarqueId: manifestoEmbarqueId,
      agenteId: this.modalItem.agenteId,
      paginaAtual: this.pagingTransporte.index,
      itensPorPagina: this.pagingTransporte.size,
      codigoBarras: this.codigoBarras,
    })
      .pipe(take(1))
      .subscribe(
        (response: HttpResponse<any>) => {
          this.transporteCollection.data = response.body;
          if (response.body.length > 0) {
            this.pagingTransporte.length = response.body[0].totalCount;
          }
          this.isLoadingTransporte = false;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoadingTransporte = false;
          this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
        });
  }

  public onChangeEvent() {
    this.error = {} as any;
  }

  public search(shouldResetPages: boolean = true) {
    this.getManifestoEmbarqueDetalhesTransporte(this.modalItem.manifestoEmbarqueId, shouldResetPages);
    if (this.pagingDevolucao.length != 0) {
      this.getManifestoEmbarqueDetalhesDevolucao(this.modalItem.manifestoEmbarqueId, shouldResetPages);
    }
  }

  public clearFields() {
    this.codBarrasDetalheForm.reset();
    this.codigoBarras.nativeElement.focus();
  }

  public baixarME() {
    this.isDownloading = true;
    this.service.baixarME({
      manifestoId: this.modalItem.manifestoEmbarqueId,
      agenteId: this.modalItem.agenteId
    })
      .pipe(take(1))
      .subscribe(() => {
        this.isDownloading = false;
        this.ref.close();
        this.openSnackBar('ME Baixado com sucesso!', 'OK', 5000);
      }, (errorResponse) => {
        this.isDownloading = false;
        this.ref.close();
        this.threatErrorAndSearch(errorResponse);
      });
  }

  public openModalMEPedidos(meDetalheItem: any, isDevolucao: boolean): void {
    console.log(meDetalheItem);
    const modalReference = this.dialog.open(ModalManifestoDetalhesEmbarqueComponent, {
      width: '1300px',
      maxWidth: '90vw',
      data: { item: { meDetalheItem: meDetalheItem, isDevolucao, manifestoEmbarqueId: this.modalItem.manifestoEmbarqueId, agenteId: this.modalItem.agenteId } }
    });

    modalReference.afterClosed().subscribe(() => { });
  }

  public onPageChangeDevolucao(evt: { pageIndex: number, pageSize: number }) {
    this.pagingDevolucao.index = evt.pageIndex;
    this.pagingDevolucao.size = evt.pageSize;
    this.getManifestoEmbarqueDetalhesDevolucao(this.modalItem.manifestoEmbarqueId, false);
  }

  public onPageChangeTransporte(evt: { pageIndex: number, pageSize: number }) {
    this.pagingTransporte.index = evt.pageIndex;
    this.pagingTransporte.size = evt.pageSize;
    this.getManifestoEmbarqueDetalhesTransporte(this.modalItem.manifestoEmbarqueId, false);
  }

  private resetOrNotPagination(shouldResetPagination: boolean) {
    if (shouldResetPagination === true) {
      this.pagingTransporte.index = 0;
      this.pagingDevolucao.index = 0;
      if (this.paginator)
        this.paginator.goTo = 1;
    }
  }

  private threatErrorAndSearch(errorResponse) {
    if (errorResponse.status === 409) {
      this.openSnackBar(errorResponse.error, 'Ok', 5000, 'danger-snackbar');
    }
    else {
      this.openSnackBar('Desculpe, aconteceu um erro!', 'Ok', 3000, 'danger-snackbar');
    }

    setTimeout(() => this.search(), 200);
  }


  private openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
